module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"school":"Achat solidaire"},"en":{"school":"Solidarity purchase"},"de":{"school":"Solidarischer Einkauf"},"es":{"school":"Compra solidaria"},"it":{"school":"Acquisto solidale"},"nl":{"school":"Solidaire aankoop"},"pt":{"school":"Compra solidária"}}')
  delete Component.options._Ctor
}
